import { takeLatest, call, put, take, select } from 'redux-saga/effects';
import { auth, websocket, loading, toast } from '../types';
import Cookies from 'universal-cookie';
import config from '../config';
import { getRootDomain, setWhatsappAlternateMobilePopup, setOIDCToken, removeCookiesOnLogout, GetCookieEnvName, setOrgId } from '../utils/common';
import { tutorialList } from '../common/Tutorial/Tutorial';
import { trackSupportTicket } from '../router/roleWisePageRoute';
import axios from 'axios';
import { getAuthRoute, redirectUrlAuth } from '../router/Routes';
import scogo_apis from '../scogo_apis';
import { GET_ONBOARDING_PROGRESS_SUCCESS } from '../types/user';
import { GET_PREFERENCES_REQUEST, GET_PREFERENCES_SUCCESS } from '../types/utils';

const cookies = new Cookies();


export function* signOutUser(action) {
    const location = window.location.pathname;
    try {

        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName: 'logout', isLoading: true } });
        const name = GetCookieEnvName();
        let session_id = cookies.get(`${name}:session_id`);
        let session_token = cookies.get(`${name}:session_token`);
        const response = yield call(fetch, `${config.authDomain}/api/v1/logout`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                session_id,
                session_token
            }),
        });
        removeCookiesOnLogout();

        // Send Intalk logout message
        window.postMessage({ type: 'user_logout' }, '*');

        if (response.ok) {
            const navigate = action.payload;
            localStorage.removeItem('chatBoxElementData')
            localStorage.removeItem(redirectUrlAuth);
            const tutorialKeyList = tutorialList.map((element) => element.key)
            Object.keys(localStorage).forEach(key => {
                if (!tutorialKeyList.includes(key)) {
                    localStorage.removeItem(key)
                }
            })
            setWhatsappAlternateMobilePopup("no")
            localStorage.removeItem('__scogo_notifications');
            yield put({ type: auth.RESET_REDUX_STORE });
            if (location === trackSupportTicket.path) {
                navigate(trackSupportTicket.path);
            } else {
                const url = yield call(getAuthRoute);
                window.open(url, "_self")
            }
            yield put({ type: websocket.DISCONNECT_FROM_WEBSOCKET_REQUEST });
        }
    } catch (error) {
        console.error(error);
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName: 'logout', isLoading: false } });
}

export function* getUserProfile(action) {
    const { navigate = () => { }, give_actions = true, callPreference = true } = action.payload;
    try {
        yield put({ type: loading.GET_USER_PROFILE_LOADING, payload: true });
        const newUserResponse = yield call(scogo_apis.user.getNewUser, {}, {}, { give_actions });
        if (newUserResponse.status === 200) {
            if (newUserResponse.data.org.id) setOrgId(newUserResponse.data.org.id);
            const userData = newUserResponse.status === 200 ? newUserResponse.data.user : {};
            if (!userData.is_onboarded) {
                let progressResponse = undefined;
                try {
                    progressResponse = yield call(scogo_apis.user.onboardingProgress, {}, {}, {});
                    if (progressResponse.status === 200 && progressResponse.data && progressResponse.data.data) {
                        yield put({ type: GET_ONBOARDING_PROGRESS_SUCCESS, payload: progressResponse.data.data })
                    }
                } catch (err) {
                    console.error('Error fetching onboarding progress:', err);
                }
            }
            const roles = newUserResponse.data.user.roles.map((role) => role.id).join(',');
            if (callPreference) {
                yield put({ type: GET_PREFERENCES_REQUEST, payload: { user_id: userData.id, org_id: newUserResponse.data.org.id, role_id: roles, module: 'TABS', type: 'TAB' } });
                yield take(GET_PREFERENCES_SUCCESS);
            }
            if (newUserResponse.data) {
                yield put({ type: auth.USER_PROFILE_SUCCESS, payload: { ...newUserResponse.data, user: { ...userData } } });
            }
        } else {
            yield put({ type: auth.SIGN_OUT_USER, payload: navigate });
        }
    } catch (error) {
        yield put({ type: auth.SIGN_OUT_USER, payload: navigate });
        yield put({ type: auth.USER_PROFILE_FAILURE, payload: { message: 'Oops Something went wrong', isFailedToLogin: true } })
    }
    yield put({ type: loading.GET_USER_PROFILE_LOADING, payload: false });
}


export function* getOIDCToken(action) {
    const { code, navigate, state } = action.payload;
    try {
        const name = GetCookieEnvName()
        const codeVerifier = cookies.get(`${name}:code_verifier`);
        const storedState = cookies.get(`${name}:state`);

        if (!codeVerifier || !state) {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Invalid code verifier or state' } });
            window.location.replace('/');
            return;
        }

        if (storedState !== state) {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Invalid state' } });
            cookies.remove(`${name}:code_verifier`, { path: '/' });
            cookies.remove(`${name}:state`, { path: '/' });
            window.location.replace('/');
            return;
        }
        const response = yield call(axios.get, `${config.authDomain}/oauth/v2/token?grant_type=authorization_code&code=${code}&client_id=${config.authClient}&redirect_uri=${encodeURIComponent(`${window.location.origin}/auth/callback`)}&code_verifier=${codeVerifier}`, { method: 'GET' });
        if (response.status === 200) {
            const data = response.data
            const rootDomain = getRootDomain();
            setOIDCToken({ ...data, options: { domain: rootDomain } });
            yield put({ type: auth.USER_PROFILE_REQUEST, payload: { navigate } });
            yield take([auth.USER_PROFILE_SUCCESS, auth.USER_PROFILE_FAILURE]);
            // Let the router handle the redirect URL via getDefaultRoute
            // Don't navigate here to avoid conflicts with the default route logic
            navigate('/');
        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: response.data.message.message } });
        }
    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error.message || 'Something went Wrong!' } });
    }
    cookies.remove(`${name}:code_verifier`, { path: '/' });
    cookies.remove(`${name}:state`, { path: '/' });
}

export function* saveUserOnboardData(action) {
    let { org, step_label, has_skipped, fields, formName, onSuccess, isLastStep, navigate, role_ids, step_title } = action.payload;
    fields = fields.map(({ ref, data_type, value }) => {
        return { ref, value: value ? value : '' }
    });
    const data = { org, step_label, has_skipped, fields };
    if (role_ids) data.role_ids = role_ids;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.user.saveOnboardData, {}, {}, {}, data);
        if (response.status === 201) {
            let message = `${step_label} Details Added Successfully!!!`
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message } });
            onSuccess && onSuccess();
            if (isLastStep && navigate) {
                yield put({ type: auth.USER_PROFILE_REQUEST, payload: { navigate } });
                const res = yield take([auth.USER_PROFILE_SUCCESS, auth.USER_PROFILE_FAILURE]);
                if (res.type === auth.USER_PROFILE_SUCCESS) {
                    navigate('/');
                }
            }
        }
    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages[0] || 'Something went wrong' } });
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });

}

export function* getIntalkCredentials(action) {
    try {
        const newLoggedUserData = yield select(state => state.auth.newLoggedUserData);
        const response = yield call(scogo_apis.alert.getIntalkCredentials, {}, {}, {}, { org_id: newLoggedUserData.org.id });
        if (response.status === 201) {
            yield put({ type: auth.GET_INTALK_CREDENTIALS_SUCCESS, payload: response.data });
        }
    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages[0] || 'Something went wrong' } });
    }
}

export default function* authSaga() {
    yield takeLatest(auth.SIGN_OUT_USER, signOutUser);
    yield takeLatest(auth.USER_PROFILE_REQUEST, getUserProfile);
    yield takeLatest(auth.GET_OIDC_TOKENS_REQUEST, getOIDCToken);
    yield takeLatest(auth.UPDATE_USER_ONBOARD_DATA_REQUEST, saveUserOnboardData);
    yield takeLatest(auth.GET_INTALK_CREDENTIALS_REQUEST, getIntalkCredentials);
};